import { getDefaultSaveState, ISavesManager, ISaveState } from '@core/saves/saves.interface';
import { Observable, Subject } from 'rxjs';
import { Leerkr8Objective } from './leerkr8/types';

export class MemorySaverService implements ISavesManager {
  private onLoginSubject = new Subject<string>();
  onLogin$: Observable<string> = this.onLoginSubject.asObservable();

  state: ISaveState = getDefaultSaveState();

  objectives: Leerkr8Objective[] = [];

  async save(state: Partial<ISaveState>): Promise<void> {
    this.state = { ...this.state, ...state } satisfies ISaveState;
  }

  addPlaythroughObjective(objectives: Leerkr8Objective): void {
    this.objectives.push(objectives);
  }

  async startPolling(): Promise<void> {
    // throw new Error('Method not implemented.');
  }

  async stopPolling(): Promise<void> {
    // throw new Error('Method not implemented.');
  }

  async load(): Promise<ISaveState> {
    return this.state;
  }

  async login(playerCode: string): Promise<void> {
    this.onLoginSubject.next(playerCode);
    return;
  }

  isLoggedIn(): boolean {
    return true;
  }

  logout(): void {
    return;
  }
}
